import {cs}       from "./chain-services";
import {UseState} from "./use-state";

export const NumberInputBinding = ({state, isValid = (v) => true, defaultValue=undefined, onFlush=undefined, next}) => cs(
    ["buffer", (_, next) => UseState({next, _key: "number-input-binding-buffer", initValue: null})],
    ({buffer}) => next({
        value: buffer.value ?? state.value ?? defaultValue ?? "",
        onChange: (e) => {
            const raw = e.target.value;
            buffer.onChange(raw);

            if (raw === "") {
                state.onChange(null);

            } else if (!isNaN(raw) && isValid(+raw)) {
                state.onChange(+raw);
            }
        },
        onBlur: () => {
            buffer.onChange(null);
            onFlush?.();
        },
    }),
);
